module.exports = __webpack_public_path__ + "media/npc_dota_hero_skeleton_king.8c68d147.webm";